import React, { Component } from 'react'
import { Col, Radio, Button, Spin } from 'antd'

// 组件导入
import PreparatoryTeamApplication from './PreparatoryTeamApplication'   //筹备组申请
import PreparationTeamApplication from './PreparationTeamApplication'   //筹备队申请
import OfficialTeamApplication from './OfficialTeamApplication'         //正式队申请
class teamApplication extends Component {
    // 组件内部
    constructor(props) {
        super(props)
        this.state = {
            sub_type: '1',  //当前组件展示的操作栏
            spin:true,  //Spin组件


            page: undefined,    //操作子组件 PreparatoryTeamApplication 的展示，过程为 子组件使用setDafaultView方法修改当前page，然后将page传给子组件
            
            setPage:false,  //配合下一个参数使用，在子组件的componentDidUpdate钩子调用，防止组件多次渲染
            setPageToApplication: false,    //操作子组件 PreparatoryTeamApplication 的展示，过程为 子组件使用setPageToApplicationFun方法修改当前setPageToApplication，然后将setPageToApplication传给子组件
        }

    }

    componentDidMount() {
        this.setState({
            spin:false  //Spin组件
        })
    }

    handleChangeSub = async (sub_type) => {
        await this.setState({ sub_type })   //修改当前组件展示
    }

    // 修改当前所在page页
    // setPage(page) {
    //     //把子组件传递过来的值赋给this.state中的属性
    //     this.setState({
    //         page: page
    //     });
    // }

    setPageToApplicationFun(setPageToApplication) {
        this.setState({
            setPageToApplication: setPageToApplication
        });
    }

    setDafaultView = (setPage) => {
        this.setState({
            setPage:setPage
        })
        
    }

    // 页面渲染区
    render() {
        let { sub_type, page, setPageToApplication } = this.state
        let content_node = null
        let content_title = "无"

        switch (sub_type) {
            case '1':
                content_title = "筹备组申请"
                content_node = (<PreparatoryTeamApplication setPageToApplication={setPageToApplication} setPageToApplicationFun={this.setPageToApplicationFun.bind(this)} setPage={this.state.setPage} setDafaultView={this.setDafaultView} />)
                break
            case '2':
                // content_title = "筹备队申请"
                // content_node = (<PreparationTeamApplication />)

                break
            case '3':
                // content_node = (<OfficialTeamApplication />)
                break

        }
        return (
            <Spin spinning={this.state.spin}>
                <div className="teamApplication" style={{ padding: 30 }}>
                    <div>
                        <div className="headerNav" style={{ display: 'flex', justifyContent: 'space-between', }}>
                            <Col  >
                                <Radio.Group value={sub_type} buttonStyle="solid" className="no-select"
                                    onChange={(e) => this.setState({ sub_type: e.target.value })}>
                                    <Radio.Button value="1" onClick={()=>this.setState({
                                        setPage:true
                                    })}>筹备组申请</Radio.Button>
                                    <span style={{color:'red'}}>   注：目前系统已完成【筹备组申请】功能，【筹备组转筹备队】和【筹备队转正式队】功能陆续更新中.....</span>
                                    {/* <Radio.Button value="2" >筹备组转筹备队申请</Radio.Button> */}
                                    {/* <Radio.Button value="3" >筹备队转正式队申请</Radio.Button> */}
                                </Radio.Group>
                            </Col>

                            <Col>
                                <Button style={{ backgroundColor: '#1890FF', color: '#fff', paddingLeft: 15, paddingRight: 15 }} onClick={() => this.setState({ setPageToApplication: true })}>我的申请</Button>
                            </Col>
                        </div>
                    </div>


                    <div style={{ padding: 30 }}>
                        {
                            content_node
                        }
                    </div>

                </div>
            </Spin>


        )
    }
}



export default teamApplication



// WEBPACK FOOTER //
// ./src/routes/teamApplication/TeamApplication.jsx